import React from 'react'
import {BadgeCheckIcon} from '@heroicons/react/outline'
import { useRecoilState } from 'recoil'
import { quizInput } from '../../recoil/quiz'

const TrueAnswerSelect = () => {
  const [input, setInput] = useRecoilState(quizInput);

  const changeTrueAnswer = (index) => {
    let newInput = {...input};
    newInput.true_answer = index;
    setInput(newInput);
  }

  const handleChange = (e) => {
    let value = parseInt(e.target.value);
    console.log(typeof value);
    changeTrueAnswer(value);
  };

  const loadAnswers = () => {
    return (
      <select onChange={handleChange} value={input.true_answer} name="true_answer" id="true_answer" className="w-full p-0 bg-transparent border-none focus:ring-0">
          <option value="">Pilih Jawaban Benar</option>
          {
            input.answers.map((item, i) => (
              <option key={i} value={i}>{item}</option>
            ))
          }
      </select>
    );
}

  return (
    <div className="flex flex-col items-start">
        <label htmlFor="true_answer" className="text-sm">Jawaban Benar <span className="text-xs text-red-500">{"(wajib dipilih)"}</span></label>
        <div className="flex items-center w-full gap-5 px-5 py-3 mt-2 rounded-lg bg-slate-50">
            <BadgeCheckIcon className="w-6 h-6" />
            {loadAnswers()}
        </div>
    </div>
  )
}

export default TrueAnswerSelect